import { documentTitleFromFilename, fileType, formatBytes } from "./files.js"

export function reviewRows(container) {
  return Array.from(container.querySelectorAll("[data-package-upload-target='row']"))
}

export function reviewField(row, name) {
  return row.querySelector(`[data-upload-field='${name}']`)
}

export function captureReviewValues(rows) {
  return rows.reduce((valuesByFile, row) => {
    const fileKey = row.dataset.fileKey
    const values = {
      title: reviewField(row, "title").value,
      category: reviewField(row, "category").value,
      periodKind: reviewField(row, "periodKind").value,
      periodYear: reviewField(row, "periodYear").value,
      periodMonth: reviewField(row, "periodMonth").value,
      status: reviewField(row, "status")?.value
    }
    const matchingValues = valuesByFile.get(fileKey) || []
    matchingValues.push(values)
    valuesByFile.set(fileKey, matchingValues)

    return valuesByFile
  }, new Map())
}

export function takeReviewValues(valuesByFile, fileKey) {
  return valuesByFile.get(fileKey)?.shift()
}

export function reviewFileKey(file, sourcePath) {
  return JSON.stringify([ sourcePath, file.size, file.lastModified, file.type ])
}

export function renderReviewRows({ container, template, files, savedRows, defaults }) {
  container.replaceChildren()

  files.forEach((file, index) => {
    const row = buildReviewRow(template, index)
    const sourcePath = file.webkitRelativePath || file.name
    const fileKey = reviewFileKey(file, sourcePath)
    const saved = takeReviewValues(savedRows, fileKey) || takeReviewValues(savedRows, sourcePath)

    row.dataset.fileKey = fileKey
    row.dataset.rowIndex = index
    row.style.setProperty("--row-index", Math.min(index, 8))
    reviewDisplay(row, "fileType").textContent = fileType(file.name)
    reviewDisplay(row, "fileName").textContent = file.name
    reviewDisplay(row, "filePath").textContent = sourcePath
    reviewDisplay(row, "filePath").hidden = sourcePath === file.name
    reviewDisplay(row, "fileSize").textContent = formatBytes(file.size)
    reviewField(row, "sourcePath").value = sourcePath
    reviewField(row, "title").value = saved?.title || documentTitleFromFilename(file.name)
    reviewField(row, "category").value = saved?.category ?? defaults.category
    reviewField(row, "periodKind").value = saved?.periodKind ?? defaults.periodKind
    reviewField(row, "periodYear").value = saved?.periodYear ?? defaults.periodYear
    reviewField(row, "periodMonth").value = saved?.periodMonth ?? defaults.periodMonth
    const status = reviewField(row, "status")
    if (status) status.value = saved?.status ?? defaults.status ?? "draft"
    syncReviewPeriodFields(row)
    container.append(row)
  })
}

export function renumberReviewRows(rows) {
  rows.forEach((row, index) => {
    row.dataset.rowIndex = index
  })
}

export function syncReviewPeriodFields(row) {
  const kind = reviewField(row, "periodKind").value
  const yearField = row.querySelector("[data-upload-period-field='year']")
  const monthField = row.querySelector("[data-upload-period-field='month']")
  const year = reviewField(row, "periodYear")
  const month = reviewField(row, "periodMonth")

  yearField.hidden = kind === ""
  monthField.hidden = kind !== "monthly"
  year.required = kind !== ""
  month.required = kind === "monthly"
}

export function reviewPeriodSignature(row) {
  const kind = reviewField(row, "periodKind").value

  return {
    kind,
    year: kind === "" ? "" : reviewField(row, "periodYear").value,
    month: kind === "monthly" ? reviewField(row, "periodMonth").value : ""
  }
}

function buildReviewRow(template, index) {
  const row = template.content.firstElementChild.cloneNode(true)
  const elements = [ row, ...row.querySelectorAll("*") ]

  elements.forEach(element => {
    Array.from(element.attributes).forEach(attribute => {
      if (!attribute.value.includes("__INDEX__")) return

      element.setAttribute(attribute.name, attribute.value.replaceAll("__INDEX__", index))
    })
  })

  return row
}

function reviewDisplay(row, name) {
  return row.querySelector(`[data-upload-display='${name}']`)
}
